import { memo } from 'react';
// import { Path as _Path, Rect as _Rect, Svg as _Svg } from 'react-native-svg'
import { Path as _Path, Rect as _Rect, Svg as _Svg } from 'react-native-svg';
import { themed } from './themed';

const Icon = (props) => {
  const { color, size } = props;
  return (
    <_Svg
      width={size}
      height={size}
      viewBox="0 0 45 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <_Path
        d="M41.0001 25.7273H33.6318V6.05301H40.997C41.2014 6.0526 41.4039 6.09262 41.5929 6.17077C41.7818 6.24893 41.9536 6.36369 42.0983 6.50848C42.243 6.65328 42.3577 6.82526 42.4361 7.0146C42.5144 7.20393 42.5547 7.4069 42.5547 7.61187V24.1684C42.5547 24.5819 42.3909 24.9784 42.0994 25.2707C41.8078 25.5631 41.4124 25.7273 41.0001 25.7273Z"
        stroke="#393939"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <_Path
        d="M33.6093 5.96188L31.3684 4.83987C30.5002 4.40616 29.5443 4.18302 28.5727 4.18616H8.17251C7.30861 4.18725 6.47484 4.50467 5.82788 5.07877C5.18092 5.65288 4.7653 6.44414 4.65913 7.30388L2.17375 23.3922C2.09821 23.8927 2.12931 24.4036 2.265 24.8912C2.40069 25.3789 2.63789 25.8321 2.96097 26.2211C3.28405 26.6101 3.68566 26.926 4.13936 27.1481C4.59305 27.3701 5.08852 27.4932 5.59311 27.5093H19.2455V36.5827C19.2498 37.0447 19.3463 37.5012 19.5294 37.9252C19.7124 38.3491 19.9783 38.7321 20.3113 39.0514C20.6443 39.3706 21.0377 39.6198 21.4683 39.7842C21.8989 39.9486 22.358 40.0248 22.8184 40.0084C23.404 40.0146 23.9812 39.8685 24.4937 39.5842C25.0062 39.3 25.4365 38.8874 25.7426 38.3867L33.6406 25.7273V6.05302"
        stroke="#393939"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </_Svg>
  );
};
Icon.displayName = 'NotHelpFullRegular';
const NotHelpFullRegular = memo(themed(Icon));
export { NotHelpFullRegular };
